<div class="wrapper">
  <div
    *ngFor="let p of countdownParts$ | async | keyvalue; trackBy: trackByFn"
    [ngClass]="segmentLabel === 'long' ? 'long-labels' : 'short-labels'"
    class="segment">
    <span class="num subtitle">{{ p.value }}</span>
    <span class="label footnote">{{ segmentLabels[p.key] }}</span>
  </div>
</div>
